import api from "./api";
import {API_FILES} from "../constants/urls"

/**
 * Servicio cargar archivos
 */

export const file = {
    upload: async (file, companyName) => {
        const formData = new FormData();
        formData.append("image", file);
        const res = await api.post(`${API_FILES}/${companyName}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
        return res.data
    },
    
}